<template>
  <nav class="app-header" style="z-index: 3">
    <v-toolbar
      color="#FAF9F7"
      height="70"
      class="main-nav__toolbar"
    >
      <button
        type="button"
        class="main-nav__brand"
        @click="NavigateToMain()"
      >
        <img
          src="@/assets/LanghamLogo.png"
          alt=""
          class="main-nav__brand-logo"
        />
        <span class="main-nav__brand-copy">
          <span class="main-nav__brand-name">The Langham Custom House</span>
          <span class="main-nav__brand-subtitle">
            PARKING REDEMPTION MANAGEMENT
          </span>
        </span>
      </button>
      <v-spacer></v-spacer>
      <div class="main-nav__actions">
        <v-menu
          offset-y
          :close-on-content-click="true"
          content-class="main-nav__menu main-nav__language-menu"
        >
          <template v-slot:activator="{ on, attrs, value }">
            <button
              type="button"
              class="main-nav__language"
              :class="{ 'main-nav__control--open': value }"
              :aria-label="`Change language. Current language: ${$i18n.locale}`"
              :aria-expanded="String(value)"
              v-bind="attrs"
              v-on="on"
            >
              <img
                src="@/assets/icons/globalicon.png"
                alt=""
                class="main-nav__globe"
              />
              <span
                :class="{ 'main-nav__language--active': $i18n.locale === 'th' }"
              >
                TH
              </span>
              <span class="main-nav__language-divider">/</span>
              <span
                :class="{ 'main-nav__language--active': $i18n.locale === 'en' }"
              >
                EN
              </span>
              <span class="main-nav__control-chevron" aria-hidden="true"></span>
            </button>
          </template>
          <v-list class="main-nav__menu-list" role="menu">
            <v-list-item
              v-for="language in ['th', 'en']"
              :key="language"
              class="main-nav__menu-item main-nav__language-item"
              :class="{ 'main-nav__menu-item--active': $i18n.locale === language }"
              @click="setLanguage(language)"
            >
              <v-list-item-title>{{ language.toUpperCase() }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
          offset-y
          content-class="main-nav__menu main-nav__user-menu"
        >
          <template v-slot:activator="{ on, attrs, value }">
            <button
              type="button"
              class="main-nav__user"
              :class="{ 'main-nav__control--open': value }"
              :aria-expanded="String(value)"
              v-bind="attrs"
              v-on="on"
            >
              <span class="main-nav__username">{{ Username }}</span>
              <span class="main-nav__control-chevron" aria-hidden="true"></span>
            </button>
          </template>
          <v-list class="main-nav__menu-list" role="menu">
            <v-list-item
              v-for="(item, index) in itemsMenu"
              :key="index"
              class="main-nav__menu-item"
              @click="ActionMenu(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>

    <v-dialog v-model="EditUserDialog" persistent width="800">
      <v-card class="change-password-dialog">
        <v-card-title class="change-password-dialog__header">
          <span class="change-password-dialog__title">
            {{ $t("message.ChangePassword") }}
          </span>
          <v-btn
            class="change-password-dialog__close"
            icon
            aria-label="Close"
            @click="CloseEditUserDialog()"
          >
            <v-icon color="white" size="30">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="change-password-dialog__body">
          <v-row class="change-password-dialog__fields">
            <v-col cols="12" md="6">
              <v-text-field
                disabled
                outlined
                dense
                hide-details
                :label="$t('message.Username')"
                v-model="Username"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                dense
                hide-details
                :label="$t('message.OldPassword')"
                type="password"
                id="oldpassword"
                v-model="EditOldPassword"
                :append-icon="flagOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="TogglePassword"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                dense
                hide-details
                :label="$t('message.NewPassword')"
                type="password"
                id="newpassword"
                v-model="EditPassword"
                :append-icon="flagPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="ToggleNewPassword"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                dense
                hide-details
                :label="$t('message.ConfirmNewPassword')"
                type="password"
                id="confirmpassword"
                v-model="EditConfirmPassword"
                :append-icon="flagConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="ToggleConfirmPassword"
              />
            </v-col>
          </v-row>
          <v-card-actions class="change-password-dialog__actions">
            <v-btn
              color="#231F20"
              class="change-password-dialog__submit white--text text-capitalize"
              @click="ChangePassword()"
            >
              {{ $t("message.Submit") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
  data() {
    return {
      url: enurl.apiUrl,
      Username: this.$cookies.get("Username"),
      StatusAdmin: false,

      EditUserDialog: false,
      flagOldPassword: false,
      flagPassword: false,
      flagConfirmPassword: false,

      itemsMenu: [],

      EditUsername: "",
      EditOldPassword: "",
      EditPassword: "",
      EditConfirmPassword: "",

      projectName: localStorage.getItem("ProjectSiteName"),
      projectID: localStorage.getItem("ProjectID"),
    };
  },

  mounted() {
    let self = this;
    self.GetDataPermission();
  },

  methods: {
    NavigateToMain() {
      let self = this;
      const currentRoute = self.$route.path;
      if (currentRoute !== "/MainMenu") {
        self.$router.push("/MainMenu");
      } else {
        self.$router.push("/ProjectSite");
      }
    },

    ActionMenu(data) {
      let self = this;
      switch (data.id) {
        case 1:
          self.$router.push("/ManageUser");
          break;
        case 2:
          self.ManageRole();
          break;
        case 3:
          self.$router.push("/ManageQuotaRate");
          break;
        case 4:
          self.EditUser();
          break;
        case 5:
          self.Logout();
          break;
      }
    },

    EditUser() {
      let self = this;
      let token = localStorage.getItem("Token");
      self.GetDataUserByToken(token);
    },

    ManageRole() {
      let self = this;
      self.$router.push("/ManageRole");
    },

    GetDataPermission() {
      let self = this;
      axios
        .get(`${self.url}Permission/getDataMenuPermission`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.StatusAdmin = response.data.data.manageUser;
            self.itemsMenu = [];
            if (response.data.data.manageUser == true) {
              self.itemsMenu.push({
                title: "Manage User",
                id: 1,
              });
            }
            if (response.data.data.manageUser == true) {
              self.itemsMenu.push({
                title: "Manage Role",
                id: 2,
              });
            }
            // if(response.data.data.manageUser == true){
            //   self.itemsMenu.push({
            //     title: "Manage Quota Rate",
            //     id: 3,
            //   });
            // }
            self.itemsMenu.push({
              title: "Change Password",
              id: 4,
            });
            self.itemsMenu.push({ title: "Logout", id: 5 });
          }
        })
        .catch(function (error) {
          console.warn(error);
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    GetDataUserByToken(token) {
      let self = this;
      let temp = {
        token: token,
      };
      axios
        .post(`${self.url}Login/GetDataUserByToken`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.MappingEditUser(response.data.data);
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            text:
              error?.response?.data?.message ||
              error?.message ||
              String(error),
          });
        });
    },

    ChangePassword() {
      let self = this;
      if (self.EditPassword != self.EditConfirmPassword) {
        Swal.fire({
          icon: "error",
          width: 900,
          text: "กรุณากรอก Password ให้ถูกต้องและตรงกัน",
        });
      }
      self.LoadingDialog = true;
      let temp = {
        oldPassword: self.EditOldPassword,
        newPassword: self.EditPassword,
      };
      axios
        .post(`${self.url}Login/ChangePassword`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.Logout();
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    MappingEditUser(data) {
      let self = this;
      self.EditUsername = data.username;
      self.EditUserDialog = true;
    },

    CloseEditUserDialog() {
      let self = this;
      self.EditOldPassword = "";
      self.EditPassword = "";
      self.EditConfirmPassword = "";
      self.EditUserDialog = false;
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("oldpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagOldPassword = false;
      } else {
        x.type = "password";
        self.flagOldPassword = true;
      }
    },

    ToggleNewPassword() {
      let self = this;
      var x = document.getElementById("newpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagPassword = false;
      } else {
        x.type = "password";
        self.flagPassword = true;
      }
    },

    ToggleConfirmPassword() {
      let self = this;
      var x = document.getElementById("confirmpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagConfirmPassword = false;
      } else {
        x.type = "password";
        self.flagConfirmPassword = true;
      }
    },

    Logout() {
      let self = this;
      self.$store
        .dispatch("Logout")
        .then(function () {
          self.$router.push("/Login");
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    toggleLanguage() {
      this.GetDataPermission();
      this.$i18n.locale = this.$i18n.locale === "en" ? "th" : "en";
    },

    setLanguage(language) {
      if (this.$i18n.locale === language) return;
      this.$i18n.locale = language;
      this.GetDataPermission();
    },
  },
};
</script>
<style>
.app {
  margin-left: 1rem;
  cursor: pointer;
}
.list {
  cursor: pointer;
}
.apptitle {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.v-list-item__content {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.mdi-menu-down::before {
  color: black;
}
.white-color {
  background-color: red;
  color: red;
}
.item-title {
  font-size: 16px;
  font-weight: 500;
}
.main-nav__toolbar {
  /* border-top: 3px solid #126496 !important; */
  border-bottom: 1px solid #333333 !important;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.2) !important;
}
.main-nav__toolbar > .v-toolbar__content {
  padding-right: 30px;
  padding-left: 30px;
}
.main-nav__brand {
  min-width: 0;
  max-width: 60vw;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 18px;
  color: #231f20;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.main-nav__brand-logo {
  width: 50px;
  height: 50px;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}
.main-nav__brand-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.main-nav__brand-name {
  max-width: 100%;
  overflow: hidden;
  font-family: "Mrs Eaves Lining OT", serif;
  font-size: 30px;
  line-height: 0.95;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main-nav__brand-subtitle {
  margin-top: 5px;
  font-family: "Mrs Eaves Small Caps OT", serif;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.main-nav__actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.main-nav__language,
.main-nav__user {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Mrs Eaves Small Caps OT", serif;
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}
.main-nav__language {
  min-width: 154px;
  height: 32px;
  padding: 0 10px;
  gap: 7px;
  color: #777373;
  background-color: #ffffff;
  border: 1px solid #8b8785;
  border-radius: 18px;
}
.main-nav__language--active,
.main-nav__language-divider {
  color: #231f20;
}
.main-nav__globe {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  margin-right: 1px;
}
.main-nav__user {
  width: 100.97px;
  min-width: 100.97px;
  max-width: 100.97px;
  height: 29.17px;
  padding: 0 8px;
  gap: 8px;
  color: #ffffff;
  background-color: #555051;
  border: 0;
  border-radius: 18px;
}
.main-nav__username {
  width: 60px;
  overflow: hidden;
  font-size: 20px;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
}
.main-nav__control-chevron {
  width: 12.12px;
  height: 8.75px;
  flex-shrink: 0;
  margin-left: 3px;
  background-color: currentColor;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  transition: transform 180ms cubic-bezier(0.22, 1, 0.36, 1);
}
.main-nav__language .main-nav__control-chevron {
  color: #231f20;
}
.main-nav__control--open .main-nav__control-chevron {
  transform: rotate(180deg);
}
.main-nav__brand:focus-visible,
.main-nav__language:focus-visible,
.main-nav__user:focus-visible {
  outline: 3px solid #126496;
  outline-offset: 2px;
}
.main-nav__menu {
  margin-top: 8px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #333031;
  border-radius: 11px;
  box-shadow: none;
}
.main-nav__language-menu {
  width: 154px;
  min-width: 154px !important;
}
.main-nav__user-menu {
  width: 145px;
  min-width: 145px !important;
}
.main-nav__menu-list {
  padding: 0 !important;
  background: #ffffff !important;
}
.main-nav__menu-item {
  min-height: 36px !important;
  padding: 0 13px !important;
  color: #262223 !important;
  cursor: pointer;
}
.main-nav__menu-item::before {
  display: none;
}
.main-nav__menu-item:hover,
.main-nav__menu-item:focus,
.main-nav__menu-item--active {
  background: #e8e8e8 !important;
}
.main-nav__menu-item .v-list-item__title {
  overflow: visible;
  font-family: "Mrs Eaves Lining OT", serif !important;
  font-size: 17px !important;
  line-height: 1.15;
  letter-spacing: 0.01em;
  text-overflow: clip;
}
.main-nav__language-item {
  min-height: 36px !important;
  padding-left: 20px !important;
}
.change-password-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}
.change-password-dialog__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  padding: 0 52px !important;
  color: #ffffff;
  background: #231f20;
}
.change-password-dialog__title,
.change-password-dialog__body .v-label,
.change-password-dialog__body input,
.change-password-dialog__submit {
  font-family: "Mrs Eaves Lining OT", serif !important;
}
.change-password-dialog__title {
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 0.02em;
}
.change-password-dialog__close {
  position: absolute !important;
  top: 9px;
  right: 12px;
}
.change-password-dialog__body {
  min-height: 326px;
  padding: 62px 40px 28px !important;
}
.change-password-dialog__fields {
  margin: -8px !important;
}
.change-password-dialog__fields > .col {
  padding: 8px !important;
}
.change-password-dialog__body .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 50px !important;
  border-radius: 12px !important;
  background: #ffffff !important;
}
.change-password-dialog__body .v-text-field--outlined fieldset {
  border-color: #403c3d !important;
}
.change-password-dialog__body .v-input--is-disabled input,
.change-password-dialog__body .v-input--is-disabled .v-label {
  color: #514d4e !important;
}
.change-password-dialog__body .v-input--is-disabled fieldset {
  border-color: #403c3d !important;
}
.change-password-dialog__body .v-label {
  color: #777373;
  font-size: 16px;
}
.change-password-dialog__body input {
  color: #231f20 !important;
  font-size: 17px;
}
.change-password-dialog__body .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
}
.change-password-dialog__body .v-input__append-inner .v-icon {
  color: #231f20 !important;
  font-size: 26px;
}
.change-password-dialog__actions {
  justify-content: center;
  padding: 68px 0 0 !important;
}
.change-password-dialog__submit {
  min-width: 150px !important;
  height: 46px !important;
  margin: 0 !important;
  border-radius: 24px;
  box-shadow: 0 7px 10px rgba(35, 31, 32, 0.24) !important;
  font-size: 18px !important;
  letter-spacing: 0.02em;
}
@media (max-width: 959px) {
  .main-nav__toolbar > .v-toolbar__content {
    padding-right: 20px;
    padding-left: 20px;
  }
  .main-nav__brand {
    gap: 14px;
  }
  .main-nav__brand-logo {
    width: 48px;
    height: 48px;
  }
  .main-nav__brand-name {
    font-size: 26px;
  }
  .main-nav__brand-subtitle {
    margin-top: 4px;
    font-size: 13px;
  }
  .change-password-dialog__body {
    padding: 28px 24px 24px !important;
  }
  .change-password-dialog__actions {
    padding-top: 28px !important;
  }
}
@media (max-width: 600px) {
  .main-nav__toolbar > .v-toolbar__content {
    padding-right: 12px;
    padding-left: 12px;
  }
  .main-nav__brand {
    max-width: 46px;
  }
  .main-nav__brand-logo {
    width: 46px;
    height: 46px;
  }
  .main-nav__brand-copy {
    display: none;
  }
  .main-nav__actions {
    gap: 8px;
  }
  .main-nav__language {
    min-width: 128px;
    padding: 0 8px;
    gap: 5px;
    font-size: 16px;
  }
  .main-nav__user {
    font-size: 16px;
  }
  .main-nav__language-menu {
    width: 128px;
    min-width: 128px !important;
  }
  .main-nav__user-menu {
    width: 136px;
    min-width: 136px !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .main-nav__control-chevron {
    transition: none;
  }
}
.v-application--is-ltr
  .v-list-group--no-action.v-list-group--sub-group
  .v-list-group__items
  .v-list-item {
  padding-left: 20px !important;
}
@font-face {
  font-family: "Mrs Eaves Small Caps OT";
  src: url("~@/assets/Font/SmallCaps.otf") format("opentype");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
</style>
